/**
 * Created by manuel on 17/11/2016.
 */
import { Injectable } from '@angular/core';

import { en } from '../../../assets/lang/lang-en';
import { it } from '../../../assets/lang/lang-it';
import { ChatService } from '../../services/chat.service';

@Injectable()
export class LocaleService {
  current: string;
  private locales = { en, it };

  constructor(private chat: ChatService) {
    this.getBrowserLocale();
    this.sanitizeBrowserLocale();
  }

  getTranslations(): object {
    return this.locales[this.current] || this.locales['it'];
  }

  private getBrowserLocale() {
    if (window.navigator['languages']) {
      this.current = window.navigator['languages'][0];
    } else {
      this.current =
        window.navigator['language'] || window.navigator['browserLanguage'] || window.navigator['userLanguage'];
    }
    const chatLocale = this.current.split('-')[0];
    this.chat.setLocale(chatLocale);
  }

  private sanitizeBrowserLocale() {
    if (this.current.indexOf('-') !== -1) this.current = this.current.split('-')[0];
    else this.current = this.current.split('_')[0];

    if (!/it|en/.test(this.current)) {
      this.current = 'en';
    }
  }
}
